// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteIssueAnswerElementData, DeleteIssueAnswerElementResponses, DeleteIssueAttachmentsData, DeleteIssueAttachmentsResponses, DeleteIssueWatchersData, DeleteIssueWatchersResponses, DeleteUserData, DeleteUserResponses, GetEventsData, GetEventsResponses, GetIssueAnswerAttachmentData, GetIssueAnswerAttachmentResponses, GetIssueAnswerimportData, GetIssueAnswerimportResponses, GetIssueAnswersSearchData, GetIssueAnswersSearchResponses, GetIssueAttachmentData, GetIssueAttachmentResponses, GetIssueAttachmentsData, GetIssueAttachmentsResponses, GetIssueData, GetIssueNotesData, GetIssueNotesResponses, GetIssueQuestionAttachmentData, GetIssueQuestionAttachmentResponses, GetIssueQuestionData, GetIssueQuestionResponses, GetIssueResponses, GetIssueScoregapsData, GetIssueScoregapsResponses, GetIssuesData, GetIssueSectionData, GetIssueSectionResponses, GetIssueSectionsData, GetIssueSectionsResponses, GetIssueSectionStatsData, GetIssueSectionStatsResponses, GetIssueSectionWorkflowData, GetIssueSectionWorkflowResponses, GetIssuesResponses, GetIssueTreeData, GetIssueTreeResponses, GetIssueWatchlistData, GetIssueWatchlistResponses, GetPermissionsData, GetPermissionsResponses, GetRolesData, GetRolesResponses, GetUserData, GetUserResponses, GetUsersData, GetUsersResponses, GetWhoamiData, GetWhoamiResponses, PostIssueAllocateData, PostIssueAllocateResponses, PostIssueAnswerAttachmentData, PostIssueAnswerAttachmentResponses, PostIssueAnswerimportData, PostIssueAnswerimportResponses, PostIssueAnswersReplaceData, PostIssueAnswersReplaceResponses, PostIssueAttachmentData, PostIssueAttachmentResponses, PostIssueNoteData, PostIssueNoteResponses, PostIssueQuestionAnswersData, PostIssueQuestionAnswersResponses, PostIssueStatusData, PostIssueStatusResponses, PostIssueWatchersData, PostIssueWatchersResponses, PostIssueWorkflowData, PostIssueWorkflowResponses, PostUserData, PostUserResponses, PutUserData, PutUserResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Returns a paginated array of audit events for the user's organisation.
 * Supports paging. Requires permission MANAGE_USERS.
 */
export const getEvents = <ThrowOnError extends boolean = false>(options?: Options<GetEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetEventsResponses, unknown, ThrowOnError>({
        url: '/events',
        ...options
    });
};

/**
 * Retrieve a single Issue visible to the respondent (restricted field set including
 * project title and watch status). Visibility validated against respondent org.
 */
export const getIssue = <ThrowOnError extends boolean = false>(options: Options<GetIssueData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}',
        ...options
    });
};

/**
 * Bulk (re)assign allocated_to for specified questions in an Issue. Overwrites any
 * existing allocation and stamps allocated_by with the caller. No response body.
 * Permission: ALLOCATE_QUESTIONS.
 */
export const postIssueAllocate = <ThrowOnError extends boolean = false>(options: Options<PostIssueAllocateData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueAllocateResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/allocate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upload an attachment to provide an answer to a specific question.
 */
export const postIssueAnswerAttachment = <ThrowOnError extends boolean = false>(options: Options<PostIssueAnswerAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueAnswerAttachmentResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/issue/{issue_id}/answer/attachment',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Download a single Issue Attachment file
 */
export const getIssueAnswerAttachment = <ThrowOnError extends boolean = false>(options: Options<GetIssueAnswerAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueAnswerAttachmentResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answer/attachment/{attachment_id}',
        ...options
    });
};

/**
 * Delete the answer (and any associated attachment) for a single question element
 * in this Issue.
 */
export const deleteIssueAnswerElement = <ThrowOnError extends boolean = false>(options: Options<DeleteIssueAnswerElementData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteIssueAnswerElementResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answer/element/{element_id}',
        ...options
    });
};

/**
 * Preview importable answers from other Issues in the same Project, optionally
 * restricted to a section (node_number). Counts only; no data mutation.
 */
export const getIssueAnswerimport = <ThrowOnError extends boolean = false>(options: Options<GetIssueAnswerimportData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueAnswerimportResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answerimport',
        ...options
    });
};

/**
 * Import answers from another Issue (optionally section‑scoped). Returns imported,
 * unchanged, and error lists per question. Skips invalid or unchanged targets.
 */
export const postIssueAnswerimport = <ThrowOnError extends boolean = false>(options: Options<PostIssueAnswerimportData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueAnswerimportResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answerimport',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk in‑place text replacement (search_term -> replace_term) across all answers
 * in the Issue. Returns count of questions affected. Honors permissions & bulk_import flag.
 */
export const postIssueAnswersReplace = <ThrowOnError extends boolean = false>(options: Options<PostIssueAnswersReplaceData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueAnswersReplaceResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answers/replace',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Text search across this Issue's answers (case‑sensitive via utf8mb4_bin collation).
 * Returns matching question numbers & IDs.
 */
export const getIssueAnswersSearch = <ThrowOnError extends boolean = false>(options: Options<GetIssueAnswersSearchData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueAnswersSearchResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/answers/search',
        ...options
    });
};

/**
 * Upload an Issue attachment together with metadata (description etc)
 */
export const postIssueAttachment = <ThrowOnError extends boolean = false>(options: Options<PostIssueAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueAttachmentResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/issue/{issue_id}/attachment',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Download a single Issue Attachment file
 */
export const getIssueAttachment = <ThrowOnError extends boolean = false>(options: Options<GetIssueAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueAttachmentResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/attachment/{attachment_id}',
        ...options
    });
};

/**
 * Delete those Issue attachments whose IDs are given in the JSON body
 * document
 */
export const deleteIssueAttachments = <ThrowOnError extends boolean = false>(options: Options<DeleteIssueAttachmentsData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteIssueAttachmentsResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/attachments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * list Issue Attachments for the given Issue ID
 */
export const getIssueAttachments = <ThrowOnError extends boolean = false>(options: Options<GetIssueAttachmentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueAttachmentsResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/attachments',
        ...options
    });
};

/**
 * Create a respondent note (kind=RespondentNote). Private flag restricts visibility
 * to respondent org. Emits PROJECT_NOTE_ADDED audit event with field changes.
 */
export const postIssueNote = <ThrowOnError extends boolean = false>(options: Options<PostIssueNoteData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueNoteResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/note',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List notes visible to the respondent for this Issue (privacy / distribution
 * filtering applied).
 */
export const getIssueNotes = <ThrowOnError extends boolean = false>(options: Options<GetIssueNotesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueNotesResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/notes',
        ...options
    });
};

/**
 * A single question (by questionnaire number) with respondent-specific answer state
 * and response workflow metadata (response_state).
 */
export const getIssueQuestion = <ThrowOnError extends boolean = false>(options: Options<GetIssueQuestionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueQuestionResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/question',
        ...options
    });
};

/**
 * Save/replace answers for all elements of one question. Attachments must be uploaded
 * via the dedicated attachment endpoint (not here). Rejects empty submission.
 */
export const postIssueQuestionAnswers = <ThrowOnError extends boolean = false>(options: Options<PostIssueQuestionAnswersData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueQuestionAnswersResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/question/{question_id}/answers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download a Question Attachment.
 */
export const getIssueQuestionAttachment = <ThrowOnError extends boolean = false>(options: Options<GetIssueQuestionAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueQuestionAttachmentResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/question/{question_id}/attachment/{attachment_id}',
        ...options
    });
};

/**
 * Per‑question win/loss gap report for a respondent Issue.
 *
 * For each question the service compares this Issue’s agreed (consensus) score
 * to the highest agreed score achieved by any other scoreable respondent
 * (Submitted / Updateable) in the same Project, using the weighting set defined
 * for win/loss analysis (issue.winloss_weightset_id or 0 if unset).
 *
 * Returned fields:
 * - question_id / number / title / node_type
 * - weight (only meaningful if the Project exposes weightings)
 * - score_gap:
 * * Numeric difference (this_issue_score - best_other_score) when at least
 * 3 respondents have scores (prevents inferring a competitor’s exact score).
 * * One of "+", "-", "==" when only 2 (or fewer) scored respondents:
 * "+"  -> this Issue leads
 * "-"  -> another Issue leads
 * "==" -> tie or no comparative data
 *
 * Weightings are included only if project.expose_weightings is True.
 * Positive gap indicates an advantage; negative indicates a deficit.
 */
export const getIssueScoregaps = <ThrowOnError extends boolean = false>(options: Options<GetIssueScoregapsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueScoregapsResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/scoregaps',
        ...options
    });
};

/**
 * Full section detail including immediate subsections and answered question data for this Issue.
 */
export const getIssueSection = <ThrowOnError extends boolean = false>(options: Options<GetIssueSectionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueSectionResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/section/{section_id}',
        ...options
    });
};

/**
 * Progress metrics for a section: counts grouped by response status for this Issue.
 */
export const getIssueSectionStats = <ThrowOnError extends boolean = false>(options: Options<GetIssueSectionStatsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueSectionStatsResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/section/{section_id}/stats',
        ...options
    });
};

/**
 * Section workflow snapshot for an Issue: returns section metadata plus a paged list
 * (page size 20) of question response state rows (status, allocated/review fields,
 * question number & IDs). Supports pagination via standard pager params.
 * Permission: access to Issue & Section (implicit respondent visibility rules).
 */
export const getIssueSectionWorkflow = <ThrowOnError extends boolean = false>(options: Options<GetIssueSectionWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueSectionWorkflowResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/section/{section_id}/workflow',
        ...options
    });
};

/**
 * Flat list of all sections in the Project (IDs, parent IDs, human numbers, titles)
 * ordered by questionnaire numbering.
 */
export const getIssueSections = <ThrowOnError extends boolean = false>(options: Options<GetIssueSectionsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueSectionsResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/sections',
        ...options
    });
};

/**
 * Perform an allowed respondent status transition: Accepted, Submitted, Declined.
 * Enforces mandatory answer / deadline rules on submission. Emits audit events.
 */
export const postIssueStatus = <ThrowOnError extends boolean = false>(options: Options<PostIssueStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueStatusResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Questionnaire structure (section + optional question hierarchy) for the Issue's Project root.
 * Set q_with_questions=true to embed questions at each section node.
 */
export const getIssueTree = <ThrowOnError extends boolean = false>(options: Options<GetIssueTreeData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueTreeResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/tree',
        ...options
    });
};

/**
 * Remove users from an Issue's watch list. A user can remove themselves; bulk changes require MANAGE_USERS.
 * Returns list of user IDs removed.
 */
export const deleteIssueWatchers = <ThrowOnError extends boolean = false>(options: Options<DeleteIssueWatchersData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteIssueWatchersResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/watchers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add users to an Issue's watch list. A user can add themselves; bulk changes require MANAGE_USERS.
 * Returns list of user IDs newly added.
 */
export const postIssueWatchers = <ThrowOnError extends boolean = false>(options: Options<PostIssueWatchersData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueWatchersResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/watchers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get watch list (users watching) for an Issue visible to the caller. Includes watch timestamps.
 */
export const getIssueWatchlist = <ThrowOnError extends boolean = false>(options: Options<GetIssueWatchlistData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueWatchlistResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/watchlist',
        ...options
    });
};

/**
 * Toggle workflow usage flag for this Issue (no audit event). Permission:
 * ISSUE_UPDATE_WORKFLOW.
 */
export const postIssueWorkflow = <ThrowOnError extends boolean = false>(options: Options<PostIssueWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueWorkflowResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/workflow',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List respondent Issues (excludes Not Sent / Retracted). Ordered by most recent
 * issue_date descending.
 */
export const getIssues = <ThrowOnError extends boolean = false>(options?: Options<GetIssuesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetIssuesResponses, unknown, ThrowOnError>({
        url: '/issues',
        ...options
    });
};

/**
 * List all available permissions
 */
export const getPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetPermissionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPermissionsResponses, unknown, ThrowOnError>({
        url: '/permissions',
        ...options
    });
};

/**
 * List available role names (built‑in plus organisation custom roles) for assignment.
 */
export const getRoles = <ThrowOnError extends boolean = false>(options?: Options<GetRolesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRolesResponses, unknown, ThrowOnError>({
        url: '/roles',
        ...options
    });
};

/**
 * Delete a user in the caller's organisation. Requires MANAGE_USERS.
 * Emits USER_DELETED audit event.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retrieve a single user in the same organisation. Rejects cross‑organisation access.
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options
    });
};

/**
 * Create a new user in the caller's organisation. Requires MANAGE_USERS.
 * Emits USER_UPDATED audit event capturing initial attributes & roles.
 */
export const postUser = <ThrowOnError extends boolean = false>(options?: Options<PostUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update a user's name, email and roles. User may self‑update; otherwise MANAGE_USERS required.
 * Emits USER_UPDATED audit event with per‑field change records.
 */
export const putUser = <ThrowOnError extends boolean = false>(options?: Options<PutUserData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List users in the caller's organisation (respondent scope). Returns basic identity fields.
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({
        url: '/users',
        ...options
    });
};

/**
 * Return the authenticated user's full profile (roles & derived permissions).
 */
export const getWhoami = <ThrowOnError extends boolean = false>(options?: Options<GetWhoamiData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetWhoamiResponses, unknown, ThrowOnError>({
        url: '/whoami',
        ...options
    });
};
